import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';
import { hasBetterNav } from 'Components/UI/Navigation/Schema/advisor';
import NavigationContent from './Content';
import Loading from './Loading';


const styles = () => ({
  root: {},
});

const NavigationContainer = ({
  className,
  classes,
  collection,
  isInitializing,
  loadingError,
  open,
}) => {
  return (
    <DataContainer
      className={classNames(classes.root, className)}
      component={NavigationContent}
      componentProps={{
        navigationCollection: collection,
        open,
      }}
      layout={
        // We don't want the navigation's loader taking up as much space as possible, as that shifts content down in a flexbox container.
        // On the other hand, for a very long time now we've been using flexbox. To make this change as safe as possible, I'll *only* have it affect roadmap explorer for now
        hasBetterNav(window) ? 'block' : undefined
      }
      loading={isInitializing}
      loadingError={loadingError}
      skeleton={Loading}
    />
  );
};

NavigationContainer.defaultProps = {
  className: '',
  isInitializing: false,
  loadingError: undefined,
  open: false,
  collection: null,
};

NavigationContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object,
  isInitializing: PropTypes.bool,
  loadingError: PropTypes.object,
  open: PropTypes.bool,
};

export default withStyles(styles)(NavigationContainer);
